import React, { useState, useEffect } from "react";
import { uploadVideo } from "../api/api";
import { Link } from "react-router-dom";
import "./Dashboard.css";

interface UserUpload {
    id: string;
    video_url: string;
    documents: string[];
    created_at: string;
}

const Dashboard = () => {
    const [videoUrl, setVideoUrl] = useState("");
    const [documents, setDocuments] = useState<File[]>([]);
    const [userUploads, setUserUploads] = useState<UserUpload[]>([]);

    // Fetch user uploads when component mounts
    useEffect(() => {
        // TODO: Add API call to fetch user uploads
        // For now using dummy data
        setUserUploads([
            {
                id: "1",
                video_url: "https://example.com/video1",
                documents: ["doc1.pdf", "doc2.pdf"],
                created_at: new Date().toISOString()
            },
            {
                id: "2",
                video_url: "https://example.com/video2",
                documents: ["doc3.pdf"],
                created_at: new Date().toISOString()
            }
        ]);
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("video_url", videoUrl);
            documents.forEach(doc => {
                formData.append("documents", doc);
            });

            await uploadVideo(formData);
            alert("Upload successful!");
            setVideoUrl("");
            setDocuments([]);
        } catch (error) {
            console.error("Upload failed:", error);
            alert("Upload failed. Please try again.");
        }
    };

    return (
        <div className="dashboard-layout">
            {/* Sidebar */}
            <div className="sidebar">
                <div className="sidebar-header">
                    <div className="user-initial">TE</div>
                    <span>test</span>
                </div>
                <div className="sidebar-menu">
                    <Link to="/dashboard" className="menu-item active">
                        <i className="fas fa-home"></i>
                        <span>Home</span>
                    </Link>

                    <Link to="/docs" className="menu-item">
                        <i className="fas fa-file-alt"></i>
                        <span>Docs</span>
                    </Link>
                </div>
            </div>

            {/* Main Content */}
            <div className="main-content">
                <div className="dashboard-container">
                    <div className="dashboard-left">
                        <h2>Your Uploads</h2>
                        <div className="uploads-table-container">
                            <table className="uploads-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Video URL</th>
                                        <th>Documents</th>
                                        <th>Upload Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userUploads.map(upload => (
                                        <tr key={upload.id}>
                                            <td>{upload.id}</td>
                                            <td>
                                                <a href={upload.video_url} target="_blank" rel="noopener noreferrer">
                                                    {upload.video_url}
                                                </a>
                                            </td>
                                            <td>{upload.documents.join(", ")}</td>
                                            <td>{new Date(upload.created_at).toLocaleDateString()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="dashboard-right">
                        <form onSubmit={handleSubmit} className="dashboard-form">
                            <h2>Upload Content</h2>

                            <div className="form-group">
                                <label>Video URL:</label>
                                <input type="url" value={videoUrl} onChange={e => setVideoUrl(e.target.value)} placeholder="Enter video URL" required />
                            </div>

                            <div className="form-group">
                                <label>Documents:</label>
                                <input type="file" multiple onChange={e => setDocuments(Array.from(e.target.files || []))} accept=".pdf,.doc,.docx" />
                            </div>

                            <button type="submit" className="submit-btn">
                                Upload
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
